module.exports = __webpack_public_path__ + "img/p2.74a778d6.svg";